import _users from '../../pages/users/userSlice';
import _listUser from '../../pages/users/listUserSlice';
import _createUser from '../../pages/register/createUserSlice';
import { reducer as _groups } from '../../pages/deviceManagement/groupSlice';
import _enrollOrganization from '../../pages/orgAdminEnrollment/enrollOrganizationSlice';
import _verifyToken from '../../pages/orgAdminEnrollment/verifyTokenSlice';
import _sendEmail from '../../pages/users/superAdmin/organizationUsers/sendEmailSlice';
import _createGroup from '../../components/createEditGroupModal/createGroupSlice';
import _editGroup from '../../components/createEditGroupModal/editGroupSlice';
import { reducer as _createEditGroupModal } from '../../components/createEditGroupModal/createEditGroupModalSlice';
import { reducer as _createEditAlertModal } from '../../components/modals/createAlert/createEditAlertModalSlice';
import listPublicApiTokensReducer  from "../../pages/integrations/flashcast/listPublicApiTokenSlice";
import _revokePublicApiToken from "../../components/deletePublicTokenModal/deletePublicTokenSlice";
import _getPublicApiApprovalStatus from "../../pages/integrations/approvePublicApiUserSlice";
import _deleteModal from '../../components/deleteModal/deleteModalSlice';
import { reducer as _spinnerSlice } from '../../components/ui/spinner/spinnerSlice';
import _deleteDeviceModal from '../../components/deleteDeviceModal/deleteDeviceModalSlice';
import _pendingDeletions from '../../pages/users/superAdmin/deviceManagement/pendingDeletionsSlice';
import _updateDeviceModal from '../../components/updateDeviceModal/updateDeviceModalSlice';
import _unassignDeviceModal from '../../components/updateDeviceModal/unassignDeviceModalSlice';
import _assignDevices from '../../components/modals/assignDevices/assignDevicesSlice';
import _deleteUser from '../../components/deleteUserModal/deleteUserSlice';
import _updateUser from '../../components/updateUserModal/updateUserSlice';
import _inviteUser from '../../components/inviteUserModal/inviteUserSlice';
import _verifyUserInvitationToken from "../../pages/register/verifyUserInvitationToken";
import _getMobileLicenseUsers from "../../components/enableMobileLicensing/getMobileLicenseUsersSlice";
import _manageMobileLicenseUsers from "../../components/enableMobileLicensing/manageMobileLicenseUsersSlice";

import { reducer as _devices } from '../../pages/deviceManagement/deviceSlice';
import { reducer as _alerts } from '../../pages/alerts/listAlertsSlice';
import { reducer as _organizations } from '../../pages/users/listOrganizationSlice';
import _deleteOrganization from '../../pages/users/superAdmin/organizations/deleteOrganization/deleteOrganizationSlice';
import { reducer as _deleteAlert } from '../../components/deleteAlertModal/deleteAlertModalSlice';
import { reducer as _endAlert } from '../../components/endAlertModal/endAlertModalSlice';
import { reducer as _dasSubscriptions } from '../../pages/integrations/das/listDas/listDasSlice';
import { reducer as _deleteSubscription } from '../../components/subscriptionRow/deleteSubscriptionModal/deleteSubscriptionModalSlice';
import { reducer as _editSubscription } from '../../components/subscriptionRow/editSubscription/editSubscriptionSlice';

import { reducer as _editOrganization } from '../../components/modals/editOrgAdmin/editOrgSlice';
import { reducer as _updateOrganizationFirmwareVersion } from '../../components/modals/updateFIrmwareVersion/updateFirmwareSlice';
import { reducer as _updateOrganizationIotAgentVersion } from '../../components/modals/udpateIotAgentVersion/updateIotAgentSlice';
import { reducer as _updateOrgStatus } from '../../pages/users/superAdmin/organizations/enableDisablePopup/updateOrgStatusSlice';
import _deviceSetup from '../../pages/deviceSetUp/deviceSetupSlice';
import analyticsFilterReducer from '../../pages/analytics/slices/analyticsFilterSlice';
import organizationsAnalyticsReducer from '../../pages/analytics/slices/organizationsAnalyticsSlice';
import deviceAnalyticsReducer from '../../pages/analytics/slices/deviceAnalyticsSlice';
import alertsAnalyticsReducer from '../../pages/analytics/slices/alertsAnalyticsSlice';
import integrationsAnalyticsReducer from '../../pages/analytics/slices/integrationsAnalyticsSlice';
import versionDistributionReducer from '../../pages/analytics/slices/versionDistributionSlice';
import usersAnalyticsReducer from '../../pages/analytics/slices/usersAnalyticsSlice';

import _createAlert from '../../components/modals/createAlert/createAlertSlice';
import _singlewireToken from '../../components/addSinglewireTokenModal/addSinglewireTokenSlice';
import _editAlert from '../../components/modals/createAlert/editAlertSlice';
import _listAlertNeedsApproval from '../../pages/alerts/alertsNeedingApproval/listApprovalSlice';
import _approveAlert from '../../pages/alerts/alertsNeedingApproval/approveAlertSlice';
import _denyAlert from '../../pages/alerts/alertsNeedingApproval/denyAlertSlice';
import _resendAlert from '../../components/modals/createAlert/resendAlertSlice';

import _createDas from '../../pages/integrations/das/createDas/createDasSlice';
import _listAlertTypes from '../../pages/integrations/das/createDas/listAlertTypesSlice';

import _dashboardApi from '../../pages/dashboard/dashboardSlice';
import _deviceLogs from '../../pages/deviceLogs/deviceLogsSlice';

import _signInApi from '../../pages/login/loginSlice';
import _signOutApi from '../../containers/layout/sidebar/sidebarSlice';
import _sendResetPasswordEmailApi from '../../components/modals/sendResetPasswordEmail/sendResetPasswordEmailSlice';
import _resetPasswordApi from '../../pages/resetPassword/resetPasswordSlice';

import _listFirmwareApi from '../../pages/manageUpdates/firmwareSlice';
import _listIotAgentApi from '../../pages/manageUpdates/iotAgentSlice';
import _uploadFirmwareApi from '../../pages/manageUpdates/uploadFirmwareSlice';
import _uploadIotAgentApi from '../../pages/manageUpdates/uploadIotAgentSlice';
import _deleteFirmwareApi from '../../pages/manageUpdates/deleteDeviceExecutables/deleteFirmwareSlice';
import _deleteIotAgentApi from '../../pages/manageUpdates/deleteDeviceExecutables/deleteIotAgentSlice';
import { reducer as _sendDasAlert } from '../../pages/alerts/dasAlertSlice';

import { reducer as _alertAction } from '../../pages/alerts/alertActionSlice';
import { reducer as _singlewireSite } from '../../pages/integrations/singlewire/listSinglewireSiteSlice';
import { reducer as _mapSinglewireSites } from '../../components/mapSinglewireSiteModal/mapSinglewireSitesSlice';
import { reducer as _mapEverbridgeGroup } from '../../components/mapEverbridgeGroupModal/mapEverbridgeGroupsSlice';

import _everbridgeToken from '../../components/configureEverbridgeTokenModal/configureEverbridgeTokenSlice';
import { reducer as _everbridgeGroup } from '../../pages/integrations/everbridge/listEverbridgeGroupSlice';

import _listAlertusTokens from '../../pages/integrations/alertus/listAlertusTokenSlice';
import _deleteAlertusToken from '../../components/deleteAlertusTokenModal/deleteAlertusTokenSlice';
import _createAlertusToken from '../../components/createAlertusTokenModal/createAlertusTokenSlice';

import { reducer as _listQuickAlerts } from '../../pages/alerts/quickAlerts/listQuickAlerts/listQuickAlertsSlice';
import { reducer as _editQuickAlerts } from '../../pages/alerts/quickAlerts/editQuickAlerts/editQuickAlertSlice';
import { reducer as _deleteQuickAlerts } from '../../pages/alerts/quickAlerts/deleteQuickAlerts/deleteQuickAlertSlice';
import { reducer as _saveQuickAlertsOrder } from '../../pages/alerts/quickAlerts/listQuickAlerts/saveQuickAlertsOrderSlice';

import _createQuickAlerts from '../../pages/alerts/quickAlerts/createQuickAlerts/createQuickAlertsSlice';
import _sendQuickAlerts from '../../pages/alerts/quickAlerts/quickAlertRow/sendQuickAlertsSlice';

import { reducer as _approvePublicApiUser } from '../../pages/users/superAdmin/organizations/enableDisablePublicAPI/approvePublicApiUserSlice';

import _rebootDevice from '../../components/modals/rebootDeviceSlice';
import _organisationLicenses from '../../components/modals/licensingModal/licensingSlice';
import _mobileLicensing from '../../components/modals/mobileLicensingModal/mobileLicensingSlice';
import _deviceUpdateReport from '../../pages/users/superAdmin/organizations/deviceUpdateReportExportSlice';
import _createPublicAPIToken from '../../components/createPublicTokenModal/createPublicTokenSlice';
import _userGuide from '../../pages/userGuide/userGuideSlice';
import _templates from '../../components/superAdmin/templatesSlice';
import { reducer as _superAdminDevicesApi } from "../../pages/users/superAdmin/deviceManagement/superAdminDeviceSlice";
import { reducer as _superAdminDeleteDeviceApi } from "../../pages/users/superAdmin/deviceManagement/superAdminDeleteDeviceSlice";

import _listCapEndpoints from '../../pages/integrations/cap/listCap/listCapSlice';
import _createCapEndpoint from '../../pages/integrations/cap/createCap/createCapSlice';
import _updateCapEndpoint from '../../pages/integrations/cap/updateCapEndpointSlice';
import _deleteCapEndpoint from '../../pages/integrations/cap/deleteCapEndpointSlice';
import _regenerateCapEndpointToken from '../../pages/integrations/cap/regenerateCapEndpointTokenSlice';

// UI REDUCER
export const spinner = _spinnerSlice;

// AUTH REDUCER

export const signInApi = _signInApi;

export const signOutApi = _signOutApi;

export const sendResetPasswordEmailApi = _sendResetPasswordEmailApi;

export const resetPasswordApi = _resetPasswordApi;

// USERS REDUCER
export const users = _users;

export const createUser = _createUser;

export const listUser = _listUser;

export const deleteUser = _deleteUser;

export const updateUser = _updateUser;

export const inviteUser = _inviteUser;

export const verifyUserInvitationToken = _verifyUserInvitationToken;

export const getMobileLicenseUsers = _getMobileLicenseUsers;

export const manageMobileLicenseUsers = _manageMobileLicenseUsers;

// ORGANIZATIONS REDUCER
export const organizations = _organizations;

export const groups = _groups;

export const enrollOrganization = _enrollOrganization;

export const verifyToken = _verifyToken;

export const sendEmail = _sendEmail;

export const deleteModal = _deleteModal;

export const editOrganization = _editOrganization;

export const updateOrganizationFirmwareVersion =
  _updateOrganizationFirmwareVersion;
export const updateOrganizationIotAgentVersion =
  _updateOrganizationIotAgentVersion;

export const updateOrgStatus = _updateOrgStatus;

export const deleteOrganization = _deleteOrganization;

export const revokePublicApiToken = _revokePublicApiToken;

export const listPublicApiTokens = listPublicApiTokensReducer;

export const getPublicApiApprovalStatus = _getPublicApiApprovalStatus;

export const organisationLicenses = _organisationLicenses;
export const mobileLicensing = _mobileLicensing;

// DEVICES REDUCER
export const devices = _devices;

export const deviceSetup = _deviceSetup;

export const createGroup = _createGroup;

export const editGroup = _editGroup;

export const deleteDeviceModal = _deleteDeviceModal;
export const pendingDeletions = _pendingDeletions;

export const updateDeviceModal = _updateDeviceModal;

export const unassignDeviceModal = _unassignDeviceModal;

export const assignDevices = _assignDevices;

export const dashboardApi = _dashboardApi;

export const createEditGroupModal = _createEditGroupModal;

export const createEditAlertModal = _createEditAlertModal;

export const deviceLogs = _deviceLogs;

export const superAdminDevicesApi = _superAdminDevicesApi;

export const superAdminDeleteDeviceApi = _superAdminDeleteDeviceApi;

//ALERTS REDUCER
export const alerts = _alerts;

export const deleteAlert = _deleteAlert;
export const createAlert = _createAlert;

export const endAlert = _endAlert;

export const editAlert = _editAlert;

export const listApprovalAlertApi = _listAlertNeedsApproval;

export const approveAlertApi = _approveAlert;

export const denyAlertApi = _denyAlert;
export const resendAlert = _resendAlert;

export const alertAction = _alertAction;

// DAS REDUCER

export const createDas = _createDas;

export const listAlertTypes = _listAlertTypes;

export const dasSubscriptions = _dasSubscriptions;

export const deleteSubscription = _deleteSubscription;

export const editSubscription = _editSubscription;

export const sendDasAlert = _sendDasAlert;

export const listFirmwareApi = _listFirmwareApi;

export const listIotAgentApi = _listIotAgentApi;

export const uploadFirmwareApi = _uploadFirmwareApi;

export const uploadIotAgentApi = _uploadIotAgentApi;

export const deleteFirmwareApi = _deleteFirmwareApi;

export const deleteIotAgentApi = _deleteIotAgentApi;

// SINGLEWIRE REDUCER

export const singlewireToken = _singlewireToken;

export const singlewireSite = _singlewireSite;

export const mapSinglewireSites = _mapSinglewireSites;

// EVERBRIDGE REDUCER

export const everbridgeToken = _everbridgeToken;

export const everbridgeGroup = _everbridgeGroup;

export const mapEverbridgeGroup = _mapEverbridgeGroup;

// ALERTUS REDUCER

export const listAlertusTokens = _listAlertusTokens;
export const deleteAlertusToken = _deleteAlertusToken;
export const createAlertusToken = _createAlertusToken;

// QUICK ALERTS REDUCER

export const listQuickAlerts = _listQuickAlerts;

export const createQuickAlerts = _createQuickAlerts;

export const editQuickAlerts = _editQuickAlerts;

export const deleteQuickAlerts = _deleteQuickAlerts;

export const sendQuickAlerts = _sendQuickAlerts;

export const saveQuickAlertsOrder = _saveQuickAlertsOrder;

// PUBLIC API REDUCER
export const approvePublicApiUser = _approvePublicApiUser;
export const createPublicAPIToken = _createPublicAPIToken;
export const rebootDevice = _rebootDevice;

// ANALYTICS REDUCER
export const analyticsFilter = analyticsFilterReducer;
export const organizationsAnalytics = organizationsAnalyticsReducer;
export const deviceAnalytics = deviceAnalyticsReducer;
export const alertsAnalytics = alertsAnalyticsReducer;
export const integrationsAnalytics = integrationsAnalyticsReducer;
export const versionDistribution = versionDistributionReducer;
export const usersAnalytics = usersAnalyticsReducer;
export const deviceUpdateReport = _deviceUpdateReport;
export const userGuide = _userGuide;
export const templates = _templates;

// CAP / RAVE REDUCER
export const listCapEndpoints = _listCapEndpoints;
export const createCapEndpoint = _createCapEndpoint;
export const updateCapEndpoint = _updateCapEndpoint;
export const deleteCapEndpoint = _deleteCapEndpoint;
export const regenerateCapEndpointToken = _regenerateCapEndpointToken;